import React, { useCallback, useContext } from 'react';
import { t } from 'i18next';
import { Button, ButtonStyle, ErrorBadge, ErrorLevel } from '@sovryn/ui';
import { useAccount } from '../../../../../../hooks/useAccount';
import { translations } from '../../../../../../locales/i18n';
import { SendFlowContext, SendFlowStep } from '../../../contexts/sendflow';
import { useERC20BridgeLocked } from '../../../hooks/useERC20BridgeLocked';
import { Instructions } from '../../Instructions';
export const InitialScreen = () => {
    const { account } = useAccount();
    const { set } = useContext(SendFlowContext);
    const isBridgeLocked = useERC20BridgeLocked();
    const onContinueClick = useCallback(() => set(prevState => (Object.assign(Object.assign({}, prevState), { step: SendFlowStep.MAIN }))), [set]);
    return (React.createElement("div", null,
        React.createElement(Instructions, null),
        isBridgeLocked ? (React.createElement(ErrorBadge, { level: ErrorLevel.Warning, message: t(translations.maintenanceMode.erc20Bridge) })) : (React.createElement(Button, { disabled: !account, onClick: onContinueClick, text: t(translations.common.buttons.continue), className: "w-full", style: ButtonStyle.secondary, dataAttribute: "funding-send-instructions-confirm" }))));
};
